//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum BatchProcessingInspectionOption {
    RelevantInspections = 0,
    StartingWithDate = 1,
    AllInspections = 2,
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum BatchAnalysisStatus {
    Triggered = 0,
    Waiting = 1,
    Successfully = 2,
    Failed = 3,
    PartiallyFailed = 4,
}
